import { render, staticRenderFns } from "./FooterColumnTheme0.vue?vue&type=template&id=5e48773a&scoped=true"
import script from "./FooterColumnTheme0.vue?vue&type=script&lang=js"
export * from "./FooterColumnTheme0.vue?vue&type=script&lang=js"
import style0 from "./FooterColumnTheme0.vue?vue&type=style&index=0&id=5e48773a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48773a",
  null
  
)

export default component.exports